import { configureStore } from '@reduxjs/toolkit'

import { alertReducer } from './alertSlice'
import { authReducer } from './authSlice'
import filterReducer from './filterSlice'
import { notificationReducer } from './notificationSlice'
import { regionReducer } from './regionSlice'
import tenantReducer from './tenantSlice'

export const store = configureStore({
  reducer: {
    tenant: tenantReducer,
    filters: filterReducer,
    auth: authReducer,
    region: regionReducer,
    alert: alertReducer,
    notification: notificationReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'filters/resetFilters',
          'filters/setDateForContext',
          'filters/initializeDateContext',
          'filters/resetDateContext',
          'alert/addAlert',
          'alert/initializeMockAlerts',
          'notification/pushNotification',
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.date', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: [
          'alert.alerts',
          'filters.dateContexts', // DateContexts contain DateRange objects with Date instances
        ],
      },
    }),

  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
